module.exports = fox._r("images/mc_intro_desc.png", __webpack_public_path__ + "images/mc_intro_desc.png");


//////////////////
// WEBPACK FOOTER
// ./images/mc_intro_desc.png
// module id = 74
// module chunks = 2